module.exports = __webpack_public_path__ + "static/media/ups.cf7c683f.svg";